import Button from "@mui/material/Button";
import Paper from "@mui/material/Paper";
import Stack from "@mui/material/Stack";
import TextField from "@mui/material/TextField";
import {
  et3ParseInteger,
  getOnlyDigitsFromString,
  isDefinedString,
  isPositiveNumber
} from "et3-type-guards";
import { runInAction } from "mobx";
import i18n from "../../../../constants/i18n";
import { MAXIMUM_PHONE_NUMBER_DIGITS_ALLOWED } from "../../../../constants/input-entries-constants";
import { PAYMENT_LIMIT } from "../../../../constants/picker-entries-constants";
import { withLiteObserverAndTheme } from "../../../../core/et3-enhanced-render";
import getUserPaymentsStore from "../../../../stores/user-store/payments-store";
import FilterSelect from "../../../khattabat/matching/search-and-101m/form/FilterSelect";

const KhattabatUserPaymentsForm = withLiteObserverAndTheme(() => {
  const {
    userIdInput,
    transactionIdInput,
    invoiceNumberInput,
    paymentLimit,
    setUserIDInput,
    setInvoiceNumber,
    setPaymentLimit,
    searchUserPaymentsByUserId,
    getUserPaymentByTransactionId,
    getUserPaymentByInvoiceNumber
  } = getUserPaymentsStore();
  const userID = userIdInput.get();

  return (
    <Paper variant="outlined" sx={{ p: 2 }}>
      <Stack spacing={2}>
        <Stack
          direction="row"
          spacing={2}
          alignItems="center"
          flexWrap="wrap"
          useFlexGap
        >
          <TextField
            size="small"
            label={i18n.get("USER_ID")}
            value={isPositiveNumber(userID) ? `${userID}` : ""}
            onChange={({ target }) => {
              const parsedStringValue = getOnlyDigitsFromString(target.value);
              if (
                parsedStringValue.length < MAXIMUM_PHONE_NUMBER_DIGITS_ALLOWED
              ) {
                setUserIDInput(et3ParseInteger(parsedStringValue));
              }
            }}
            onKeyDown={(event) => {
              if (event.key === "Enter" && isPositiveNumber(userID)) {
                searchUserPaymentsByUserId();
              }
            }}
            slotProps={{ htmlInput: { inputMode: "numeric" } }}
            sx={{ minWidth: 200 }}
          />
          <TextField
            size="small"
            label={i18n.get("TRANSACTION_ID")}
            value={transactionIdInput.get()}
            onChange={({ target }) =>
              runInAction(() => transactionIdInput.set(target.value))
            }
            sx={{ minWidth: 200 }}
          />
          <TextField
            size="small"
            label={i18n.get("INVOICE_NUMBER")}
            value={invoiceNumberInput.get()}
            onChange={({ target }) => setInvoiceNumber(target.value)}
            sx={{ minWidth: 200 }}
          />
          <Stack sx={{ minWidth: 160 }}>
            <FilterSelect
              label={i18n.get("LIMIT")}
              options={PAYMENT_LIMIT}
              value={paymentLimit.get()}
              onChange={setPaymentLimit}
            />
          </Stack>
        </Stack>
        <Stack
          direction="row"
          spacing={1.5}
          flexWrap="wrap"
          useFlexGap
          justifyContent="flex-end"
        >
          <Button
            variant="contained"
            disabled={!isPositiveNumber(userID)}
            onClick={searchUserPaymentsByUserId}
            sx={{ whiteSpace: "nowrap" }}
          >
            {i18n.get("SEARCH_BY_USER_ID")}
          </Button>
          <Button
            variant="contained"
            disabled={!isDefinedString(transactionIdInput.get())}
            onClick={getUserPaymentByTransactionId}
            sx={{ whiteSpace: "nowrap" }}
          >
            {i18n.get("SEARCH_BY_TRANSACTION_ID")}
          </Button>
          <Button
            variant="contained"
            disabled={!isDefinedString(invoiceNumberInput.get())}
            onClick={getUserPaymentByInvoiceNumber}
            sx={{ whiteSpace: "nowrap" }}
          >
            {i18n.get("SEARCH_BY_INVOICE_NUMBER")}
          </Button>
        </Stack>
      </Stack>
    </Paper>
  );
});

export default KhattabatUserPaymentsForm;
